module.exports = __webpack_public_path__ + "assets/img/techstars-master-logo-white.2897e26f.png";